/**
 * Hide Smile.io Rewards launcher on the cart page (mobile) and whenever the
 * cart drawer is open, so it does not cover the checkout button.
 */
(function () {
  var HIDE_CLASS = 'tv-hide-smile-launcher';
  var NODE_CLASS = 'tv-smile-launcher-hidden';
  var KNOWN_SELECTORS = [
    '#smile-ui-lite-container',
    '#smile-ui-container',
    '#smile-ui-lite-root',
    '#smile-ui-lite-launcher-frame-container',
    '[id^="smile-ui-lite-launcher"]',
    'iframe[name="smile-ui-lite-launcher-frame"]'
  ].join(',');

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function cartDrawerIsOpen() {
    var drawer = document.getElementById('cart-drawer');
    return !!(drawer && drawer.hasAttribute('open'));
  }

  function shouldHide() {
    if (!document.body) return false;
    if (cartDrawerIsOpen()) return true;
    if (document.body.classList.contains('template-cart') && isMobile()) return true;
    return false;
  }

  function markLaunchers(hide) {
    try {
      document.querySelectorAll(KNOWN_SELECTORS).forEach(function (el) {
        el.classList.toggle(NODE_CLASS, hide);
        el.setAttribute('aria-hidden', hide ? 'true' : 'false');
      });
    } catch (err) {}
  }

  function sync() {
    if (!document.body) return;
    var hide = shouldHide();
    document.body.classList.toggle(HIDE_CLASS, hide);
    markLaunchers(hide);
  }

  function start() {
    sync();

    document.addEventListener('on:cart-drawer:after-open', sync);
    document.addEventListener('on:cart-drawer:after-close', sync);
    document.addEventListener('on:cart-drawer:before-open', sync);
    document.addEventListener('smile-ui-loaded', sync);
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);

    if (typeof MutationObserver !== 'function') return;

    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      new MutationObserver(sync).observe(drawer, {
        attributes: true,
        attributeFilter: ['open', 'aria-hidden']
      });
    }

    var scheduled = false;
    new MutationObserver(function () {
      if (!shouldHide() || scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        sync();
      });
    }).observe(document.body, { childList: true });
  }

  function playCartCandies() {
    var icon = document.getElementById('cart-icon');
    if (!icon) return;
    var sparks = icon.querySelector('.tv-cart-sparks');
    if (!sparks) return;
    sparks.classList.remove('is-sparkling');
    void sparks.offsetWidth;
    sparks.classList.add('is-sparkling');
  }

  document.addEventListener('on:cart:add', playCartCandies);
  document.addEventListener('on:line-item:change', function (event) {
    var detail = event.detail || {};
    if (detail.newQuantity > detail.oldQuantity) playCartCandies();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
